// Date per le schermate: giorno di oggi in Italia, giorno prima/dopo, giorno scritto per esteso.
import { lingua } from '../i18n.js';
import { adessoRoma } from '../logica/agenda.js';

export const oggiRoma = () => adessoRoma().data;

export function spostaGiorno(k, n) {
  const [y, m, d] = k.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d + n)).toISOString().slice(0, 10);
}

export function giornoLungo(k) {
  if (!k) return '';
  const [y, m, d] = k.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString(lingua() === 'en' ? 'en-GB' : 'it-IT',
    { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
}

/** Ora di un evento dello storico: «4/10 11:02» (ora italiana). */
export function quandoBreve(ts) {
  const d = ts?.toDate ? ts.toDate() : null;
  if (!d) return '…';
  const x = (o) => d.toLocaleString('it-IT', { timeZone: 'Europe/Rome', ...o });
  return `${x({ day: 'numeric' })}/${x({ month: 'numeric' })} ${x({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })}`;
}
